module.exports = __webpack_public_path__ + "static/media/horizontal-rule.3751a1a6.svg";